import { Image } from 'expo-image'
import { cssInterop } from 'nativewind'
import React from 'react'
import { Pressable, Text, View } from 'react-native'
import { twMerge } from 'tailwind-merge'

import { IMAGE } from '@ui-kit/assets/images/index.native'
import Icon from '@ui-kit/components/Icon'
import Tag from '@ui-kit/components/Tag'
import { card } from '@ui-kit/components/cards/Card/styles'
import { bgColor, borderColor } from '@ui-kit/styles/colors'

import * as styles from './styles'
import type { NativeProps } from './types'

cssInterop(Image, {
  className: {
    target: 'style',
  },
})

const CallToActionCard = (props: NativeProps): JSX.Element => {
  const contentStyle = props.contentStyle || 'dark'
  const chevronSource =
    contentStyle === 'light'
      ? IMAGE.icons.small.action.chevronRightUiLight_24
      : IMAGE.icons.small.action.chevronRight_24

  const leftIcon = props.icon || null
  const showActionIcon = props.showActionIcon !== false
  const actionIcon = showActionIcon
    ? props.actionIcon || <Icon imgSrc={chevronSource} alt="Open/close arrow" />
    : null
  const {
    container,
    image,
    content,
    title,
    subtitle,
    tagContainer,
    subtitleContainer,
    subtitleIconContainer,
  } = styles.callToActionCard({
    style: contentStyle,
  })
  const { container: cardContainer } = card({
    borderless: false,
  })

  const renderTitle = () => {
    if (typeof props.title === 'string' && props.title === '') {
      return null
    }

    if (typeof props.title === 'string') {
      return (
        <Text className={title()} accessibilityRole="header">
          {props.title}
        </Text>
      )
    }
    return props.title
  }

  const renderSubtitle = () => {
    if (typeof props.subtitle === 'string') {
      return <Text className={subtitle()}>{props.subtitle}</Text>
    }
    return props.subtitle
  }

  return (
    <Pressable
      className={twMerge(
        cardContainer(),
        borderColor({
          color: props.borderColor ?? props.bgColor ?? 'uiGreyMedium',
        }),
        props.bgColor && bgColor({ color: props.bgColor }),
        container(),
        props.className
      )}
      onPress={props.onPress}
      testID={props.testID}
      style={props.style}
    >
      {leftIcon}
      {props.imageUrl ? (
        <Image className={image()} source={props.imageUrl} alt={`Illustration of ${props.title}`} />
      ) : null}
      <View className={content()}>
        {props.tagLabel ? (
          <View className={tagContainer()} testID="CALL_TO_ACTION_TAG">
            <Tag label={props.tagLabel} type={props.tagType} />
          </View>
        ) : null}
        {renderTitle()}
        {props.subtitle ? (
          <View className={subtitleContainer()}>
            {props.subtitleIcon ? (
              <View className={subtitleIconContainer()}>{props.subtitleIcon}</View>
            ) : null}
            {renderSubtitle()}
          </View>
        ) : null}
      </View>
      {actionIcon}
    </Pressable>
  )
}

export default CallToActionCard
